import { dateLocaleTexts } from './date'
import { formLocaleTexts } from './form'

export const commonLocaleTexts = {
  form: formLocaleTexts,
  date: dateLocaleTexts,
}
